/* eslint-disable import/no-duplicates */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useReducer } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// import { ExportToCsv } from 'export-to-csv';
import { isObjectEmpty } from '../../shared/helper';
import { soHelperObj } from './soHelper';
import { sodownload } from '../../shared/assets/images';

const StreamOverlayTableView = (props) => {
  const { fileName, reqPropAr } = props;
  const { t } = useTranslation();
  // for force re-render
  // const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
  useReducer(x => x + 1, 0);
  // const [tableCol, setColumn] = useState([]);
  // const [rowData, setRow] = useState([]);
  // const products = useSelector(state => state.data);
  useSelector(state => state.data);
  const stream_ouput_data = JSON.parse(localStorage.getItem('stream_ouput_data')) || {};
  const stream_input_dict = JSON.parse(localStorage.getItem('stream_input_dict')) || {};
  const stream_input_no = Object.keys(stream_input_dict);
  stream_input_no.unshift(0);
  const unit_set_dict = JSON.parse(localStorage.getItem('unit_set_dict')) || {};
  // const reqPropArDefault = ['source','destination','flow','press','tds','ph','malk', 'hardness', 'density', 'osmotic_pressure', 'conductivity'];
  // const [reqPropAr, setReqPropAr] = useState([...reqPropArDefault]);
  const Ions = ['Ca++', 'Mg++', 'Na+', 'K+', 'NH4+', 'Ba++', 'Sr++', 'Fe++', 'Mn++', 'SO4--', 'Cl-', 'F-', 'NO3-', 'Br-', 'PO4---', 'B-', 'SiO2', 'H2S', 'HCO3-', 'CO2', 'CO3--'];
  const StreamProp = ['malk', 'ph', 'toc', 'temp', 'tds', 'flow', 'press', 'hardness', 'density', 'ionic_str'];
  const SaturationDataP = ['baso4', 'caf2', 'srso4', 'caso4', 'struvite', 'sio2', 'mgoh2'];
  const SaturationDataV = ['lsi', 'sdi', 'osmotic_pressure'];
  let column = [];
  // const [column, setColumn] = useState([]);
  // const column = useMemo(
  //   () => [],
  //   [],
  // );
  // const [tableRow, setTableRow] = useState([]);
  const tableRow = [];
  function getValue(item, num) {
    return Number.parseFloat(item).toFixed(num);
  }
  function getPercentage(item) {
    return `${Number.parseFloat(item).toFixed(0)}%`;
  }
  function getUnitValue(item) {
    if (item.includes('Pressure'))
      return `${unit_set_dict.Pressure}` || 'atm';
    if (item === 'Flow')
      return `${unit_set_dict['Volume Flow']}` || 'gpm';
    if (item === 'Temperature')
      return `${unit_set_dict.Temperature}` || '°C';
    return '';
  }
  if (isObjectEmpty(stream_ouput_data) && isObjectEmpty(stream_input_dict)) { // if both object is not empty
    const inputCol = Object.keys(stream_ouput_data);
    // const col = [...inputCol];
    let col;
    if (localStorage.getItem('streamNum_dict')) {
      col = Object.keys(JSON.parse(localStorage.getItem('streamNum_dict')));
      col.sort((a, b) => a - b); // by abhishek -> to sort the key b4 generating TableColumn
      col.unshift('prop');
      const sortcol = col.map(item => {
        return { accessorKey: `${item}`, header: `${item}`, minSize: 70, maxSize: 70 };
      });
      // setColumn(sortcol);
      column = sortcol;
      const inputRow = inputCol.map((item) => {
        const o = stream_ouput_data[item];
        const rest = { [item]: { ...o.prop_dict, ...o.ppm_dict, ...o.sat_indices, ...stream_input_dict[item], 'streamName': o.label } };
        return rest;
      });
      const finalRow = {};
      for (let i = 0; i < inputRow.length; i += 1) {
        const row = inputRow[i];
        const key = Object.keys(row)[0];
        const value = row[key];  // make let when unCommnet below Abhishek's code*
        const filteredValue = {};
        for (let j = 0; j < reqPropAr.length; j += 1) {
          const prop = reqPropAr[j];
          if (Ions.includes(prop)) filteredValue[prop] = getValue(value[prop], 3);
          // Abhishek's code* start for to add hardness
          // else if (StreamProp.includes(prop)) {
          //   if(prop === 'hardness'){
          //     if(value[prop] === 0 || value['Ca++'] > 0 ||  value['Mg++'] > 0){
          //       value = {...value, hardness : (value['Ca++'] * 2.51) + (value['Mg++'] * 4.11)};
          //     }
          //   }
          //   filteredValue[prop] = getValue(value[prop], 2);
          // }
          // Abhishek's code* end for to add hardness  // commnet just below line
          else if (StreamProp.includes(prop)) filteredValue[prop] = getValue(value[prop], 2);
          else if (SaturationDataV.includes(prop)) filteredValue[prop] = getValue(value[prop], 2);
          else if (SaturationDataP.includes(prop)) filteredValue[prop] = getPercentage(value[prop]);
          // else if (Object.prototype.toString.call(value[prop] === '[object Number]')) filteredValue[prop] = getValue(value[prop], 2);
          else {
            filteredValue[prop] = value[prop];
            if (Object.prototype.toString.call(value[prop]) === '[object Number]') {
              filteredValue[prop] = getValue(value[prop], 2);
            }
          };
        }
        finalRow[key] = filteredValue;
      }
      // const trow = [];
      for (let i = 0; i < reqPropAr.length; i += 1) {
        const tempObj = {};
        for (let j = 0; j < inputCol.length; j += 1) {
          tempObj.source = stream_input_dict[inputCol[j]]?.source || '';
          tempObj.destination = stream_input_dict[inputCol[j]]?.destination || '';
          tempObj.prop = soHelperObj[reqPropAr[i]];
          if (tempObj.prop === 'Flow') tempObj.prop = `${t('Flow')}, ${getUnitValue('Flow')}`;
          if (tempObj.prop === 'Temperature') tempObj.prop = `${t('Temperature')}, ${unit_set_dict.Temperature}`;
          if (tempObj.prop === 'Pressure') tempObj.prop = `${t('Pressure')}, ${getUnitValue('Pressure')}`;
          if (tempObj.prop === 'Osmotic Pressure') tempObj.prop = `${t('Osmotic Pressure')}, ${getUnitValue('Osmotic Pressure')}`;
          if (tempObj.prop === 'Stream Name') tempObj.prop = `${t('Stream Name')}`;
          // if(tempObj.prop ===  'Conductivity at 25°C, µS/cm ') tempObj.prop = `${t('Conductivity'), 'µS/cm'}`;
          tempObj[inputCol[j]] = finalRow[inputCol[j]][reqPropAr[i]];

        }
        // trow.push(tempObj);
        tableRow.push(tempObj);
      }

    } // end of condition
    // setTableRow(trow);
    // setColumn(column);
    // setRow(tableRow);
  }
  // useEffect(() => {
  //   forceUpdate();  // commneted by Abhishek on 21-8-24 : buz we r not using it
  // }, []);
  // setColumn(column);
  // setRow(tableRow);
  // Download Table as CSV
  function downloadCSVFile(csv_data) {
    // Create CSV file object and feed
    // our csv_data into it
    const CSVFile = new Blob([csv_data], {
      type: 'text/csv'
    });
    // Create to temporary link to initiate
    // download process
    const temp_link = document.createElement('a');
    // Download csv file
    temp_link.download = `${fileName.split('.json')[0]}.csv`;  // fileName
    const url = window.URL.createObjectURL(CSVFile);
    temp_link.href = url;
    // This link should not be displayed
    temp_link.style.display = 'none';
    document.body.appendChild(temp_link);
    // Automatically click the link to
    // trigger download
    temp_link.click();
    document.body.removeChild(temp_link);
  }
  function tableToCSV() {
    // Variable to store the final csv data
    let csv_data = [];
    // Get each row data
    const table = document.querySelector('#tableView');
    if (table) {
      const rows = table.querySelectorAll('tr');
      for (let i = 0; i < rows.length; i += 1) {
        // Get each column data
        let cols;
        if (i === 0) {
          cols = rows[i].querySelectorAll('div>div>div');
        } else {
          cols = rows[i].querySelectorAll('td,th');
        }
        // Stores each csv row data
        const csvrow = [];
        for (let j = 0; j < cols.length; j += 1) {
          // Get the text data of each cell of a row and push it to csvrow
          const text = cols[j].innerHTML;
          let textValue = cols[j].innerHTML;
          if (text.includes(',')) {
            const s = text.split(',');
            textValue = `${s[0]} (${s[1]})`;
          }
          csvrow.push(textValue);
        }
        // Combine each column value with comma
        csv_data.push(csvrow.join(','));
      }
      // Combine each row data with new line character
      csv_data = csv_data.join('\n');
    }
    // Call this function to download csv file
    downloadCSVFile(csv_data);
  }
  return (
    <div id='tableView' className='soTbaleGridContainer'>
      <button type='button' onClick={tableToCSV} className='exptable'>{t('Export Table')}
        <span><img className='sodownIcon' src={sodownload} /></span>
      </button>
      <MaterialReactTable
        columns={column}
        data={tableRow}
        enableStickyHeader  // sticky header
        enableColumnFilterModes
        enablePagination={false}
        enableSorting={false} // sorting
        // exportButton={true}  // export table: Optional
        muiTableContainerProps={{ sx: { maxHeight: '210px' } }}
        enablePinning
        initialState={{ columnPinning: { left: ['prop'] }, density: 'compact' }}
        // enableColumnResizing // resize the column
        // enableDensityToggle={false} // hide toggle density
        // enableGlobalFilter={false} //disable search feature
        // enableFullScreenToggle={false} // hide full screen
        // enableColumnFilters={false} //disable all column filters
        enableColumnActions={false} // hide each column 3 vertical dot
        enableTopToolbar={false} // hide top toolbar
        enableBottomToolbar={false} // hide bottom toolbar
      />
    </div>
  );
};
export default StreamOverlayTableView;